export var PORTAL_DEFAULT = 1;
export var PORTAL_MODAL = 2;
export var PORTAL_LOADING = 3;
export var PORTAL_TOAST = 4;
//# sourceMappingURL=app-constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/components/app/app-constants.js
// module id = 34
// module chunks = 1